<ion-grid class="ion-no-padding">
  <ion-row class="ion-align-items-center">
    <ion-col size="12" size-md="auto" class="ion-justify-content-start">
      <ion-text color="dark">
        <h3>Have a question?</h3>
      </ion-text>
      <app-button type="text" href="/contact" [icon]="{ name: 'arrow-right', position: 'right' }">
        Contact Us
      </app-button>
    </ion-col>
    <ion-col class="ion-hide-md-down"></ion-col>
    <ion-col size="12" size-md="auto" class="ion-justify-content-end ion-text-right">
      <ion-text color="dark">
        <h3>Want to speak to one of our stores?</h3>
      </ion-text>
      <app-button type="text" href="/shops" [icon]="{ name: 'arrow-right', position: 'right' }">
        Contact Our Stores
      </app-button>
    </ion-col>
  </ion-row>
</ion-grid>